import withStyles from '@mui/styles/withStyles';
import _ from 'lodash';

import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import RecentSearchesBoxStore from '../../../stores/RecentSearchesBoxStore';
import RecentSearchComponent from './RecentSearchComponent.react';
import EmptyStateSearchesDestination from './EmptyStateSearchesDestination.react';
import ProfileStore from '../../../stores/ProfileStore';

import { CircularProgress } from '@mui/material';

const styles = {};

function getState() {
	return {
		profile: ProfileStore.getProfile(),
		recentSearches: RecentSearchesBoxStore.getItems(),
		isLoading: RecentSearchesBoxStore.isLoading(),
	};
}

const MAX_NUM_RECENT_SEARCHES = 5;

class RecentSearchesBox extends React.Component {
	constructor(props) {
		super(props);

		this.state = getState();

		this._onChange = this._onChange.bind(this);
	}

	getRecentSearches() {
		const { profile, recentSearches } = this.state;
		const { t } = this.props;

		if (recentSearches && recentSearches.length > 0) {
			return _.times(Math.min(recentSearches.length, MAX_NUM_RECENT_SEARCHES), (i) => {
				return <RecentSearchComponent profile={profile} search={recentSearches[i]} key={`rec-${i}`} />;
			});
		}

		return (
			<EmptyStateSearchesDestination
				title={t('RecentSearches.NoSearches.Title')}
				description={t('RecentSearches.NoSearches.Description')}
			/>
		);
	}

	render() {
		const { t } = this.props;
		const { isLoading } = this.state;

		if (isLoading) {
			return (
				<div className="recent-searches-box flex flex-center">
					<CircularProgress />
				</div>
			);
		}

		return (
			<div className="recent-searches-box" data-testid="recent-searches-box">
				<div className="title">{t('RecentSearches.Title')}</div>
				{this.getRecentSearches()}
			</div>
		);
	}

	_onChange() {
		this.setState(getState());
	}

	componentDidMount() {
		RecentSearchesBoxStore.addChangeListener(this._onChange);
	}

	componentWillUnmount() {
		RecentSearchesBoxStore.removeChangeListener(this._onChange);
	}
}

RecentSearchesBox.propTypes = {
	classes: PropTypes.object.isRequired,
	t: PropTypes.func.isRequired,
};

export default withTranslation()(withStyles(styles)(RecentSearchesBox));
